function Myanmar({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1713)">
  <path d="M31.0048 21.5647C31.648 19.8314 32 17.9566 32 15.9995C32 14.0423 31.648 12.1675 31.0048 10.4343L16 9.04297L0.995188 10.4343C0.352063 12.1675 0 14.0423 0 15.9995C0 17.9566 0.352063 19.8314 0.995188 21.5647L16 22.956L31.0048 21.5647Z" fill="#6DA544"/>
  <path d="M31.0049 10.4348C28.7442 4.342 22.8795 0 16 0C9.12061 0 3.25593 4.342 0.995239 10.4348H31.0049Z" fill="#FFDA44"/>
  <path d="M16 31.9993C22.8795 31.9993 28.7442 27.6573 31.0049 21.5645H0.995239C3.25593 27.6573 9.12061 31.9993 16 31.9993Z" fill="#D80027"/>
  <path d="M26.9718 13.5359H18.5901L16 5.56445L13.4099 13.5359H5.0282L11.8091 18.4625L9.21901 26.4341L16 21.5645L22.781 26.434L20.191 18.4625L26.9718 13.5359Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Myanmar;
